import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";

export default function getPolygonSymbol({
  markupPolygonOutlineColor,
  markupPolygonOutlineStyle,
  markupPolygonOutlineWidth,
  markupFillColor,
  markupFillStyle,
}) {
  const polygonSymbol = new SimpleFillSymbol({
    color: markupFillColor,
    style: markupFillStyle,
    outline: {
      color: markupPolygonOutlineColor,
      width: markupPolygonOutlineWidth,
      style: markupPolygonOutlineStyle || "solid",
    },
  });
  return polygonSymbol;
}
